import type { ElectronContext } from '@mimir/common/context/applicationContext';
import { getElectronIpcRenderer } from './renderer';

/**
 * The messages like onDragStart, onDevToolsShortcut are only listened to by
 * older versions (<2.0.0) of the main process. We can remove them when we no
 * longer need to support those old versions.
 *
 * restart and onPinWindow were introduced later. So we should not need to
 * support them through getElectronIpcRenderer. But still keeping the old code
 * path for uniformity.
 */

export const restartMimirDesktop = (applicationContext: ElectronContext) => {
  const restart = applicationContext.mainRequire('./utils').restart;
  if (restart) {
    restart();
    return;
  }

  getElectronIpcRenderer(applicationContext)?.send('restart');
};

export const pinWindow = (applicationContext: ElectronContext, pin: boolean) => {
  const pinWindow = applicationContext.mainRequire('./utils').pinWindow;
  if (pinWindow) {
    pinWindow(pin);
    return;
  }

  getElectronIpcRenderer(applicationContext)?.send('onPinWindow', pin);
};

export const startDrag = (applicationContext: ElectronContext, filePaths: string[], iconDataUrl: string | undefined) => {
  const startDrag = applicationContext.mainRequire('./utils').startDrag;
  if (startDrag) {
    startDrag(filePaths, iconDataUrl);
    return;
  }

  // Pre 2.0.0, onDragStart supported only a single file.
  if (filePaths.length < 1) {
    console.warn('startDrag called with empty filePaths');
    return;
  }
  getElectronIpcRenderer(applicationContext)?.send('onDragStart', filePaths[0], iconDataUrl);
};

export const openDevTools = (applicationContext: ElectronContext) => {
  const openDevTools = applicationContext.mainRequire('./utils').openDevTools;
  if (openDevTools) {
    openDevTools();
    return;
  }

  getElectronIpcRenderer(applicationContext)?.send('onDevToolsShortcut');
};
